<template>
  
  <div style="display: flex; justify-content: center; padding: 1rem">
    <video
      autoplay
      muted
      playsinline
      controls
      controlsList="nodownload noremoteplayback"
      disablePictureInPicture
      style="width: 100%; max-width: 960px; border-radius: 16px"
      :src="videoUrl"
      @contextmenu.prevent
    >
      Tu navegador no soporta video.
    </video>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "VideoPlayer",
  props: {
    fileId: { type: String, required: false },
  },
  data() {
    return {
      videoUrl: "",
    };
  },
  mounted() {
    // Llamamos al backend para obtener la URL firmada
    //const FILE_ID = "1zinrVmwdhzC3M37wo5RhVaCvNoVslpZk";
    const objetivo_id = "1269";
    axios
      .get(
        `${process.env.VUE_APP_API_URL}/api/get-signed-video-url-poc/${objetivo_id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        this.videoUrl = res.data.video_url;
      });
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.blockShortcuts);
  },
  methods: {
    blockShortcuts(e) {
      // Ctrl+S o Cmd+S → guardar página
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s") {
        e.preventDefault();
      }
      // Ctrl+U → ver código fuente
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "u") {
        e.preventDefault();
      }
      // F12 o Ctrl+Shift+I → devtools
      if (
        e.key === "F12" ||
        ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === "i")
      ) {
        e.preventDefault();
      }
    },
  },
};
</script>
